require('./resize-handler.component.scss');

class ResizeHandlerController {
  constructor(
    $scope,
    $rootScope,
    $element,
    FilterResource,
    $window,
    RouterService,
  ) {
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.FilterResource = FilterResource;
    this.$window = angular.element($window);
    this.init = {};
    this.init.x = 0;
    this.init.y = 0;
    // this.dashboardNode = this.$element.parent()[0];
    if (RouterService.isFilterEditModal) this.container = this.$element.closest('sc-filter-preview sc-dashboard')[0];
    // else this.container = this.$element.closest('sc-view .sc-view-container.sc-view-container-fit')[0];
    // document.querySelector('sc-filter-preview sc-dashboard').scrollTop;
    this.dashboardNode = this.$element.closest('sc-dashboard-node')[0];
    this.dashboard = this.$element.closest('sc-dashboard');
    this.$element.find('.resize-handle').bind('mousedown', (event) => this.onMouseDown(event));
  }

  get canChange() {
    return this.DashboardNodeController.canChange;
  }

  getNearestGridWidth(event) {
    const newW = event.clientX - this.init.x + this.init.width;
    this.cardWidth = Math.floor(newW / this.init.stepX);
    if (this.cardWidth < 1) this.cardWidth = 1;
    const steps = this.cardWidth * this.init.stepX;
    if (Math.abs(newW - steps) > Math.abs(newW - steps - this.init.stepX)) this.cardWidth += 1;
    if (this.cardWidth > 12) this.cardWidth = 12;
    return this.cardWidth * this.init.stepX;
  }

  getNearestGridHeight(event) {
    const newH = event.clientY - this.init.y + this.init.height;
    this.cardHeight = Math.floor(newH / this.init.stepY);
    if (this.cardHeight < 0) this.cardHeight = 0;
    const steps = this.cardHeight * this.init.stepY;
    if (Math.abs(newH - steps) > Math.abs(newH - steps - this.init.stepY)) this.cardHeight += 1;
    if (this.cardHeight > 36) this.cardHeight = 36;

    return this.cardHeight * this.init.stepY;
  }

  onMouseDown(event) {
    const marginVert = 7;
    this.init.height = this.dashboardNode.clientHeight;
    this.init.width = this.dashboardNode.clientWidth;
    this.cardWidth = this.filter.cardWidth;
    this.cardHeight = this.filter.cardHeight;

    // console.log(this.dashboardNode.offsetLeft, this.dashboardNode.offsetTop,);
    // const marginHorz = 0.5;
    this.init.stepX = this.init.width / this.cardWidth;

    if (this.filter.cardHeight) {
      this.init.stepY = (this.init.height + marginVert) / this.cardHeight;
    } else {
      this.init.stepY = Math.round(this.DashboardNodeController.dashboard.$element.width() /
        12 + marginVert - 2);
    }
    // this.init.stepY = this.filter.cardHeight ? this.init.height / (this.filter.cardHeight ? this.filter.cardHeight : this.filter.cardWidth);


    this.createResizeBorder();
    this.createGridRectangle();

    this.init.x = event.clientX;
    this.init.y = event.clientY;
    // console.log('bind onMouseDown', event);
    this.$window.bind('mousemove', (event) => this.onMouseMove(event));
    this.$window.bind('mouseup', (event) => this.onMouseUp(event));
  }

  createResizeBorder() {
    this.resizeBorder = angular.element('<div class="resize-border"></div>');
    this.dashboard.append(this.resizeBorder);
    // this.$element.closest('sc-dashboard').append(this.resizeBorder);
    this.resizeBorder.css('top', (this.dashboardNode.offsetTop - (this.container ? this.container.scrollTop : 0)) + 'px');
    this.resizeBorder.css('left', this.dashboardNode.offsetLeft + 'px');
    this.resizeBorder.css('height', this.init.height + 'px');
    this.resizeBorder.css('width', this.init.width + 'px');
  }

  createGridRectangle() {
    this.gridRectangle = angular.element(
      `<div class="grid-rectangle"><div> ${this.cardWidth} X ${
      this.cardHeight==0? 'Auto' : this.cardHeight} </div></div>`);
    this.dashboard.append(this.gridRectangle);
    // this.$element.closest('sc-dashboard').append(this.gridRectangle);
    this.gridRectangle.css('top', (this.dashboardNode.offsetTop - (this.container ? this.container.scrollTop : 0)) + 'px');
    this.gridRectangle.css('left', this.dashboardNode.offsetLeft + 'px');
    this.gridRectangle.css('height', this.init.height + 'px');
    this.gridRectangle.css('width', this.init.width + 'px');
  }

  changeBorderSize(event) {
    this.resizeBorder.css('height', (this.init.height - this.init.y + event.clientY) + 'px');
    this.resizeBorder.css('width', (this.init.width - this.init.x + event.clientX) + 'px');

  }

  changeGridRectangle(event) {
    const gridHeight = this.getNearestGridHeight(event);
    if (gridHeight != this.prevGridHeight) {
      this.prevGridHeight = gridHeight;
      this.gridRectangle.css('height', this.getNearestGridHeight(event) + 'px');
      this.gridRectangle[0].querySelector('div').innerText = `${this.cardWidth} X ${
      this.cardHeight==0? 'Auto' : this.cardHeight} `;
    }

    const gridWidth = this.getNearestGridWidth(event);
    if (gridHeight != this.prevGridWidth) {
      this.prevGridWidth = gridWidth;
      this.gridRectangle.css('width', this.getNearestGridWidth(event) + 'px');
      this.gridRectangle[0].querySelector('div').innerText = `${this.cardWidth} X ${
        this.cardHeight==0? 'Auto' : this.cardHeight} `;
    }

    // console.log('height', this.getNearestGridHeight(event) + 'px', 'width', this.getNearestGridWidth(event) + 'px');
  }

  onMouseMove(event) {
    this.changeBorderSize(event);
    this.changeGridRectangle(event);
  }

  onMouseUp(event) {
    this.resizeBorder.remove();
    this.gridRectangle.remove();
    // console.log(' onMouseUp', event);
    this.$window.unbind('mousemove');
    this.$window.unbind('mouseup');
    // this.onMouseMove(event);

    this.filter.cardWidth = this.cardWidth;
    this.filter.cardHeight = this.cardHeight;
    this.filter.isChanged = true;
    // this.filter.isChanged = true;
    this.DashboardNodeController.setRouterFilter();
    // console.log('карточка:',this.filter.id, this.cardWidth, this.cardHeight);
    // const filter = this.DashboardNodeController.FiltersService.findById(this.filter.id);
    // if (filter) {
    //   filter.cardWidth = this.cardWidth;
    //   filter.cardHeight = this.cardHeight;
    // }
    // this.filterData.update(this.filter);
    // this.DashboardNodeController.$scope.$apply();

    if (this.DashboardNodeController.minimized) {
      this.DashboardNodeController.toggleMinimized();
    } else this.$scope.$apply(() => {
      setTimeout(() => {
        // this.$scope.$emit('resize');
        // this.$scope.$parent.$broadcast('dashboardResize');
        this.$rootScope.$broadcast('dashboardResize');
        // window.updateSize();
      }, 100);
    });
    // this.saveFilter();
  }

  saveFilter() {
    this.FilterResource.save(this.filter, function(status, data, error) {
      if (error) {
        console.error(`Filter is not saved. Error statrus:${status}.`, error, data);
      } else {
        if (status === 422) {
          console.error(`Filter is not saved. Error statrus:${status}.`, data);
        }
      }
    });
  }

}


export const ResizeHandlerComponent = {
  template: require('./resize-handler.component.html'),
  require: {
    DashboardNodeController: '^scDashboardNode'
  },
  bindings: {
    filter: '<',
  },
  controller: ResizeHandlerController,
};



// WEBPACK FOOTER //
// ./src/view/dashboard/resize-handler/resize-handler.component.js